// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useScreenWidth } from '@tectonics/hooks';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import {
  FieldChileanZipcode,
  FieldChileanState,
  FieldChileanCity,
  FieldChileanAddress,
  FieldChileanStreetNumber,
  FieldChileanStreetComplement,
} from '../../customer-form/chilean';

export function WebpayForm(): Node {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= 640;
  const allFeatures = useAllFeatures();

  return (
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="field_chilean_zipcode">
        <FieldChileanZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_state">
        <FieldChileanState rootStyle={{ gridColumn:(isMobile? '1/3' : '1/2') }} />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_city">
        <FieldChileanCity rootStyle={{ gridColumn:(isMobile? '1/3' : '2/3') }}  />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_address">
        <FieldChileanAddress />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_street_number">
        <FieldChileanStreetNumber rootStyle={{ gridColumn:(isMobile? '1/3' : '1/2') }} />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_street_complement">
        <FieldChileanStreetComplement  rootStyle={{ gridColumn:(isMobile ? '1/3' : '2/3') }}/>
      </IfFeature>
    </Root>
  );
}


const Root = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;

  & > * {
    grid-column: 1/3;
  }
`;
